import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface StatusDef {
  /** Tailwind bg class, e.g. "bg-amber-100" */
  bg: string;
  /** Tailwind text class, e.g. "text-amber-700" */
  text: string;
  icon: IconDefinition;
  label?: string;
}

interface StatusBadgeProps {
  status: string;
  statusMap: Record<string, StatusDef>;
  /** Add animate-pulse class */
  pulse?: boolean;
  /** Replaces the label text when provided (e.g. <CountdownTimer />) */
  children?: ReactNode;
}

const BASE = 'px-2.5 py-1 rounded-full text-xs font-semibold inline-flex items-center gap-1.5 whitespace-nowrap';

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  statusMap,
  pulse = false,
  children,
}) => {
  const def = statusMap[status];

  if (!def) {
    return (
      <span className={`${BASE} bg-gray-100 text-gray-500`}>{status}</span>
    );
  }

  return (
    <span
      className={`${BASE} ${def.bg} ${def.text} ${pulse ? 'animate-pulse' : ''}`}
    >
      <FontAwesomeIcon icon={def.icon} />
      {children ?? def.label ?? status}
    </span>
  );
};

export default StatusBadge;
